// Unmissable global banner shown on every page while a superuser is
// impersonating a target user. Rendered at the top of AppLayout so it pins
// above all authenticated routes. Distinct amber color so it can't be mistaken
// for normal product chrome. The "Exit" button restores the admin session.

import { Button } from '@/components/ui/button';
import { useImpersonation } from '@/hooks/useImpersonation';
import { TriangleAlert } from 'lucide-react';

export function ImpersonationBanner() {
  const { isImpersonating, target, exit } = useImpersonation();

  if (!isImpersonating) return null;

  const who = target?.email ?? 'another user';

  return (
    <div className="flex shrink-0 items-center justify-between gap-3 border-b border-amber-500/40 bg-amber-500 px-4 py-2 text-sm font-medium text-amber-950">
      <div className="flex min-w-0 items-center gap-2">
        <TriangleAlert className="h-4 w-4 shrink-0" />
        <span className="truncate">
          Viewing as <span className="font-semibold">{who}</span> (impersonation)
          {target?.actorEmail ? (
            <span className="hidden sm:inline"> · admin: {target.actorEmail}</span>
          ) : null}
        </span>
      </div>
      <Button
        size="sm"
        variant="outline"
        onClick={exit}
        className="h-7 shrink-0 border-amber-950/30 bg-amber-100 text-amber-950 hover:bg-amber-50"
      >
        Exit
      </Button>
    </div>
  );
}
